(function(rivets) {
	rivets.formatters["prefix"] = function(string, prefix) {
		return prefix + string;
	};
})(rivets);
